module.exports = ".efos{\r\n    list-style: none;\r\n}\r\n\r\n.container-fluid {\r\n    padding: 52px 30px 0;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/info-efos/info-efos.component.css
// module id = ./src/app/info-efos/info-efos.component.css
// module chunks = main